import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/SK-web-header.png'


const _withScopeId = n => (_pushScopeId("data-v-ad84ad3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "topbar" }
const _hoisted_2 = {
  key: 1,
  id: "main-portal-navbar",
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_3 = { class: "navbar-nav" }
const _hoisted_4 = { class: "dropdown d-flex" }
const _hoisted_5 = {
  class: "nav-link dropdown-toggle",
  role: "button",
  "data-bs-toggle": "dropdown"
}
const _hoisted_6 = { class: "dropdown-menu" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "dropdown-item",
    href: "https://www.steelking.com/"
  }, "Steel King Website")
], -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "middlebar" }
const _hoisted_10 = { class: "filter" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logoStyle",
  alt: "logo"
}, null, -1))
const _hoisted_12 = { class: "pageTitle" }
const _hoisted_13 = { class: "navbar navbar-dark ski-header navbar-expand-md ThemedBackground spacing" }
const _hoisted_14 = { class: "container-fluid" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler d-md-none",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarHeader",
  "aria-controls": "navBarHeader",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_16 = {
  key: 0,
  class: "navbar-collapse collapse",
  id: "navbarHeader"
}
const _hoisted_17 = { class: "navbar-nav" }
const _hoisted_18 = { class: "nav-item dropdown" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  role: "button",
  "data-bs-toggle": "dropdown"
}, "Quoting", -1))
const _hoisted_20 = { class: "dropdown-menu" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  href: "/customer/quotetool",
  class: "dropdown-item"
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "nav-item dropdown" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  role: "button",
  "data-bs-toggle": "dropdown"
}, " FAQs / Documents", -1))
const _hoisted_26 = { class: "dropdown-menu" }
const _hoisted_27 = { class: "nav-item dropdown" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  role: "button",
  "data-bs-toggle": "dropdown"
}, "Presentation Tools", -1))
const _hoisted_29 = { class: "dropdown-menu" }
const _hoisted_30 = { class: "nav-item dropdown" }
const _hoisted_31 = { class: "nav-item dropdown" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  role: "button",
  "data-bs-toggle": "dropdown"
}, "My Account", -1))
const _hoisted_33 = { class: "dropdown-menu" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = {
  key: 0,
  class: "nav-item dropdown"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  role: "button",
  "data-bs-toggle": "dropdown"
}, "Admin", -1))
const _hoisted_38 = { class: "dropdown-menu" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = {
  key: 1,
  class: "navbar-collapse collapse",
  id: "navbarHeader"
}
const _hoisted_41 = {
  key: 0,
  class: "navbar-nav"
}
const _hoisted_42 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isAuthorized)
        ? (_openBlock(), _createBlock(_component_DxButton, {
            key: 0,
            text: "Dashboard",
            onClick: _ctx.goHome,
            height: "50px",
            "element-attr": _ctx.dashboardButton
          }, null, 8, ["onClick", "element-attr"]))
        : _createCommentVNode("", true),
      (_ctx.isAuthenticated)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("ul", _hoisted_3, [
              _createElementVNode("li", _hoisted_4, [
                _createElementVNode("a", _hoisted_5, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.givenName), 1)
                ]),
                _createElementVNode("ul", _hoisted_6, [
                  _hoisted_7,
                  (_ctx.useMSAL)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                        _createVNode(_component_router_link, {
                          class: "dropdown-item",
                          to: "/Logout"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Sign Out")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.pageTitle), 1)
      ])
    ]),
    _createElementVNode("nav", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        (!_ctx.onInfoPage && _ctx.isAuthorized)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("ul", _hoisted_17, [
                _createElementVNode("li", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("ul", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quotingRoutes, (routeData) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: routeData.title
                      }, [
                        (_ctx.onQuoteTool && routeData.key == 'Quote Tool')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                              _createElementVNode("a", _hoisted_22, _toDisplayString(routeData.title), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_23, [
                              _createVNode(_component_router_link, {
                                class: "dropdown-item",
                                to: _ctx.getRoute(routeData.route)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(routeData.title), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]))
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("li", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("ul", _hoisted_26, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqRoutes, (routeData) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: routeData.title
                      }, [
                        _createVNode(_component_router_link, {
                          class: "dropdown-item",
                          to: _ctx.getRoute(routeData.route)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(routeData.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("li", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("ul", _hoisted_29, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentationRoutes, (routeData) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: routeData.title
                      }, [
                        _createVNode(_component_router_link, {
                          class: "dropdown-item",
                          to: _ctx.getRoute(routeData.route)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(routeData.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("li", _hoisted_30, [
                  _createVNode(_component_router_link, {
                    class: "nav-link dropdown-toggle",
                    to: "/customer/coopprogram"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Co-Op Program ")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("ul", _hoisted_33, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myAccountRoutes, (routeData) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: routeData.title
                      }, [
                        (routeData.title == 'Team Members')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                              false
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    class: "dropdown-item",
                                    to: _ctx.getRoute(routeData.route)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(routeData.title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_35, [
                              _createVNode(_component_router_link, {
                                class: "dropdown-item",
                                to: _ctx.getRoute(routeData.route)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(routeData.title), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]))
                      ]))
                    }), 128))
                  ])
                ]),
                (_ctx.isAdmin || _ctx.hasIBCLogAccess)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("ul", _hoisted_38, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adminRoutes, (routeData) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: routeData.title
                          }, [
                            _createVNode(_component_router_link, {
                              class: "dropdown-item",
                              to: _ctx.getRoute(routeData.route)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(routeData.title), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        }), 128)),
                        (_ctx.isIT)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_39, [
                              _createVNode(_component_router_link, {
                                class: "dropdown-item",
                                to: "/ActiveReports"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Active Report Editor")
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.onInfoPage || !_ctx.isAuthorized)
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
              (_ctx.useMSAL)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_41, [
                    _createElementVNode("li", _hoisted_42, [
                      _createVNode(_component_router_link, {
                        class: "nav-link",
                        to: "/Logout"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sign Out")
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}